import { z } from 'zod';

export enum ChargerFeature {
    V2G = 'v2g',
    V2H = 'v2h',
    V2L = 'v2l',
    V2X = 'v2x',
}

const options: { value: string; label: string }[] = [
    { value: ChargerFeature.V2G, label: 'Vehicle 2 Grid' },
    { value: ChargerFeature.V2H, label: 'Vehicle 2 Home' },
    { value: ChargerFeature.V2L, label: 'Vehicle 2 Load' },
    { value: ChargerFeature.V2X, label: 'Vehicle 2 Anything' },
];

const ChargerFeatures = {
    validator: z.array(z.nativeEnum(ChargerFeature)),
    options,
};

export { ChargerFeatures };
